/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_PracticeInputs */

const en_gc_guides_practice = /** @type {(inputs: Gc_Guides_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try it in a workbook`)
};

const zh_gc_guides_practice = /** @type {(inputs: Gc_Guides_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在工作簿中练习`)
};

/**
* | output |
* | --- |
* | "Try it in a workbook" |
*
* @param {Gc_Guides_PracticeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_practice = /** @type {((inputs?: Gc_Guides_PracticeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_PracticeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_practice(inputs)
	return zh_gc_guides_practice(inputs)
});
export { gc_guides_practice as "gc.guides.practice" }